import { render } from "./ModalAddAndEditCategory.vue?vue&type=template&id=35b6196f&scoped=true"
import script from "./ModalAddAndEditCategory.vue?vue&type=script&lang=js"
export * from "./ModalAddAndEditCategory.vue?vue&type=script&lang=js"

import "./ModalAddAndEditCategory.vue?vue&type=style&index=0&id=35b6196f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b6196f"]])

export default __exports__